'use strict';

var DocumentObserver = require('./DocumentObserver.js');
var log = require('loglevel');


var COMPONENT_INSTANCE_DATASET_KEY_PREFIX = 'componentInstance_';


/**
 * @class
 * @classdesc Manages component definitions and intializes and destroys them upon related DOM addition and removal form the document.
 */
var ComponentManager = function() {
	this._componentDefinitions = {}; // Key is styleClass
	
	// Bind methods
	this.register = this.register.bind(this);
	this.unregister = this.unregister.bind(this);
	
	this.getInstanceForElement = this.getInstanceForElement.bind(this);
	
	this.destroy = this.destroy.bind(this);
}

ComponentManager._instance = null;



/**
 * @public Will initiate a component for each element that contains the matching the style class.
 * 
 * @param {Function} jsClass - A reference to the javascript class to construct when related elements are found. Constructor should have a signature of: element, options
 * @param {Object} options - Options object to pass to the constructor
 * @param {string} [styleClass] - If not specified will use the 'COMPONENT_STYLE_CLASS' property on jsClass.
 * @returns {boolean} Indicates if registration was successful or not.
 */
ComponentManager.prototype.register = function(jsClass, options, styleClass) {
	// Determine styleClass
	if (styleClass === undefined) {
		if (jsClass.COMPONENT_STYLE_CLASS !== undefined) {
			styleClass = jsClass.COMPONENT_STYLE_CLASS;
		} else {
			log.error('Component is missing "COMPONENT_STYLE_CLASS" property: ', jsClass);
		}
	}
	
	// Log error if a component definition already exists, and stop
	if (this._componentDefinitions[styleClass] !== undefined) {
		log.error('A component definition for "' + styleClass + '" is already registered with ComponentManager.');
		return false;
	}
	
	// Store component definition and instances
	this._componentDefinitions[styleClass] = {
		jsClass : jsClass,
		options : options,
		instances : {},
		nextInstanceKey : 0
	};
	
	// Init and destroy instance upon addition of elements with style being added or removed from document
	DocumentObserver.getInstance().onStyleClass(
		styleClass,
		this._initComponentInstances.bind(this, styleClass),
		this._destroyComponentInstances.bind(this, styleClass)
	);
	
	return true;
};


/**
 * @public
 */
ComponentManager.prototype.unregister = function(jsClass) {
	/* TODO 
		delete this._componentDefinitions[styleClass];
		opposite of: DocumentObserver.getInstance().onStyleClass(...);
		Destroy all related existences?
	*/
};


/**
 * @private
 */
function getDatasetKey(styleClass) {
	var key = COMPONENT_INSTANCE_DATASET_KEY_PREFIX + styleClass;
	return key.replace(keyNameRegExp, function(all, letter) {
		return letter.toUpperCase();
    });
}
var keyNameRegExp = new RegExp('-([a-z])', 'ig');


/**
 * @public
 * @param {Element} elem - 
 * @param {string} styleClass - 
 * @returns {Object} Instance of the JS classes backing the element for specified styleClass, or undefined .
 */
ComponentManager.prototype.getInstanceForElement = function(elem, styleClass) {
	var datasetKey = getDatasetKey(styleClass),
		componentInstanceKey = elem.dataset[datasetKey];
	
	if (componentInstanceKey !== undefined && this._componentDefinitions[styleClass] !== undefined) {
		return this._componentDefinitions[styleClass].instances[componentInstanceKey];
	}
	
	return undefined;
};


/**
 * @private
 */
ComponentManager.prototype._initComponentInstances = function(styleClass, elems) {
	for (var i = 0; i < elems.length; i++) {
		this._initComponentInstance(styleClass, elems[i]);
	}
}

/**
 * @private
 */
ComponentManager.prototype._initComponentInstance = function(styleClass, elem) {
	var datasetKey = getDatasetKey(styleClass);
	
	if (elem.dataset[datasetKey] === undefined) {
		var componentDef = this._componentDefinitions[styleClass];
		
		// Init component
		var instance = new componentDef.jsClass(elem, componentDef.options);
		
		// Store a reference in case we need to look it up later
		var instanceKey = componentDef.nextInstanceKey++;
		componentDef.instances[instanceKey] = instance;
		elem.dataset[datasetKey] = instanceKey;
		
	} else {
		log.error('A component instance for "'+ styleClass +'" definition already exists on element: ' + elem);
	}
}

/**
 * @private
 */
ComponentManager.prototype._destroyComponentInstances = function (styleClass, elems) {
	for (var i = 0; i < elems.length; i++) {
		this._destroyComponentInstance(styleClass, elems[i]);
	}
}
/**
 * @private
 */
ComponentManager.prototype._destroyComponentInstance = function (styleClass, elem) {
	/* TODO What if somebody calls "destroy()" on the instance?
	 * 		Should that some how come back to this?
	 * 		This is JS so we could modify the destroy() on instances to call this instead.
	 * 		Which then calls the actual destroy which we have moved to _destroy() or something.
	 */ 
	
	var datasetKey = getDatasetKey(styleClass);
	
	if (elem.dataset[datasetKey] !== undefined) {
		var componentDef = this._componentDefinitions[styleClass],
			instanceKey = elem.dataset[datasetKey],
			instance = componentDef.instances[instanceKey];
		
		// Call destroy on instance, if it has one.
		if (instance.destroy !== undefined) {
			instance.destroy();
		}
		
		// Remove dataset
		delete elem.dataset[datasetKey];
		
		// Delete stored reference to instance
		delete componentDef.instances[instanceKey];
	}
}

/**
 * @public
 */
ComponentManager.prototype.destroy = function () {
	ComponentManager._instance = null;
	/* TODO
	 *  Ungregister each
	 * 	Destroy all components
	 * 	Should DocumentObserver be told? Probably not	
	 */ 
}

/**
 * @public
 */
function getInstance() {
	if (ComponentManager._instance === null) {
		ComponentManager._instance = new ComponentManager();
	}
	return ComponentManager._instance;
}

module.exports = {
	getInstance : getInstance
};

